import { Button, Collapse, Paper, Stack, Text } from '@mantine/core'
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react'
import { ReactNode, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { CodeSnippet } from '@/components/ui-shared/CodeSnippet/CodeSnippet'

type ApiKeyCurlExampleProps = {
  codeSnippet: string
  title: ReactNode
  description?: ReactNode
  urlParamsSlot?: ReactNode
  showUrlParamsToggle?: boolean
}

export const ApiKeyCurlExample = ({
  codeSnippet,
  title,
  description,
  urlParamsSlot,
  showUrlParamsToggle = false
}: ApiKeyCurlExampleProps) => {
  const [isParamsOpen, setIsParamsOpen] = useState(false)

  return (
    <Paper p="md" radius="sm" withBorder>
      <Stack gap="md">
        <Text size="sm" fw={600}>
          {title}
        </Text>

        {description && <Text size="sm">{description}</Text>}

        <Stack gap="sm">
          <CodeSnippet copyValue={codeSnippet}>{codeSnippet}</CodeSnippet>

          {showUrlParamsToggle && urlParamsSlot && (
            <div>
              <Button
                variant="outline"
                size="xs"
                rightSection={
                  isParamsOpen ? (
                    <IconChevronUp size={14} />
                  ) : (
                    <IconChevronDown size={14} />
                  )
                }
                onClick={() => setIsParamsOpen((prev) => !prev)}
              >
                <FormattedMessage id="workspace.apiKeys.example.showUrlParams" />
              </Button>

              <Collapse in={isParamsOpen}>{urlParamsSlot}</Collapse>
            </div>
          )}
        </Stack>
      </Stack>
    </Paper>
  )
}
